module.exports = __webpack_public_path__ + "img/Play.d5c1ea0b.png";